/* eslint-disable id-length */
import { mixpanel, traffic2 } from '../../utils/buildAnalyticsEvents';

export const STATS_EVENTS = {
  OPEN_DOWNLOAD_METRICS: {
    ...mixpanel('GUM Open Stats Download Metrics'),
    ...traffic2('marketing.stats.open_download_metrics.click')
  },
  OPEN_CLICK_MAP_MODAL: {
    ...mixpanel('GUM Open Click Map Modal'),
    ...traffic2('marketing.stats.open_click_map_modal.click')
  },
  CLOSE_CLICK_MAP_MODAL: {
    ...mixpanel('GUM Close Click Map Modal'),
    ...traffic2('marketing.stats.close_click_map_modal.click')
  },
  STATS_CLONE_EMAIL: {
    ...mixpanel('GUM Stats Clone Email'),
    ...traffic2('marketing.stats.clone_email.click')
  },
  STATS_SHARE_EMAIL: {
    ...mixpanel('GUM Stats Share Email'),
    ...traffic2('marketing.stats.share_email.click')
  },
  STATS_VIEW_IN_BROWSER_EMAIL: {
    ...mixpanel('GUM Stats View In Browser Email'),
    ...traffic2('marketing.stats.view_in_browser_email.click')
  },
  STATS_PAGE_BACK_CLICK: {
    ...mixpanel('GUM Stats Page Back Button Clicked'),
    ...traffic2('marketing.stats_page.back_button.click')
  },
  STATS_PAGE_ENGAGEMENT_TAB_IMPRESSION: {
    ...mixpanel('GUM Stats Page Engagement Tab Shown'),
    ...traffic2('marketing.stats_page.engagement_tab.impression')
  },
  STATS_PAGE_GROWTH_TAB_IMPRESSION: {
    ...mixpanel('GUM Stats Page Growth Tab Shown'),
    ...traffic2('marketing.stats_page.growth_tab.impression')
  },
  STATS_PAGE_ERRORS_TAB_IMPRESSION: {
    ...mixpanel('GUM Stats Page Errors Tab Shown'),
    ...traffic2('marketing.stats_page.errors_tab.impression')
  },
  STATS_PAGE_DOWNLOAD_MODAL_IMPRESSION: {
    ...mixpanel('GUM Stats Page Download Stats Shown'),
    ...traffic2('marketing.stats_page.download_modal.impression')
  },
  STATS_PAGE_DOWNLOAD_MODAL_CLOSED: {
    ...mixpanel('GUM Stats Page Download Stats Closed'),
    ...traffic2('marketing.stats_page.download_modal_close.click')
  },
  STATS_PAGE_DOWNLOAD_OPTION_CLICKED: {
    ...mixpanel('GUM Stats Page Download Option Clicked'),
    ...traffic2('marketing.stats_page.download_modal_option.click')
  },
  STATS_PAGE_RECIPIENTS_FILTER_CHANGED: {
    ...mixpanel('GUM Stats Page Recipient Filter Clicked'),
    ...traffic2('marketing.stats_page.recipient_option.click')
  },
  STATS_PAGE_RECIPIENTS_PAGE_CHANGED: {
    ...mixpanel('GUM Stats Page Recipient Page Clicked'),
    ...traffic2('marketing.stats_page.recipient_page.click')
  }
};
